import qs, { ParsedQs } from "qs";
import JsCookie from "js-cookie";

import { isBrowser } from "../common/utils";
import { CountryID, CountryCode, LanguageId, LanguageCode } from "../common/enums";
import { Request, Response, CookieOptions } from "../common/types";

import { globalInfo } from "./vars";

/**
 * 用 国家Code 获取 国家ID
 */
export const countryCode2Id = (code: CountryCode): CountryID => {
  if (CountryID[code]) {
    return CountryID[code];
  } else {
    throw new Error(`countryCode(${code}) not found`);
  }
};

/**
 * 用 语言Code 获取 语言ID
 */
export const languageCode2Id = (code: LanguageCode): LanguageId => {
  if (LanguageId[code]) {
    return LanguageId[code];
  } else {
    throw new Error(`languageCode(${code}) not found`);
  }
};

/**
 * 用 国家ID 获取 国家Code
 */
export const countryId2Code = (id: CountryID): CountryCode => {
  if (CountryID[id]) {
    return CountryID[id] as CountryCode;
  } else {
    throw new Error(`countryId(${id}) not found`);
  }
};

/**
 * 获取cookie值
 */
export function getValueFromCookie(
  req: Request | undefined,
  key: string
): string | null | undefined {
  if (!key) {
    return null;
  }

  if (!isBrowser && req) {
    return req.cookies[key];
  }

  return JsCookie.get(key);
}

/**
 * cookie 设置
 */
export function setValueToCookie({
  res,
  key,
  value,
}: {
  res: Response | undefined;
  key: string;
  value: string | number;
}): void {
  const opts = globalInfo.buildEnv === "local" ? undefined : globalInfo.cookieOptions;

  if (!isBrowser && res) {
    res.cookie(key, `${value}`, opts as CookieOptions);
  } else {
    JsCookie.set(key, `${value}`, opts);
  }
}

/**
 * 获取query
 */
export function getQuery(req: Request | undefined): ParsedQs {
  if (isBrowser) {
    return qs.parse(location.search, { ignoreQueryPrefix: true });
  } else if (req) {
    return req.query;
  }
  return {};
}
